<template>
    <div class="container-broker-delete">
        <p>Selecione um <strong>CORRETOR</strong> para receber os dados do usuário(a) <strong>{{user.name}}</strong> </p>
        <p>O usuário selecionado passará a fazer parte das filas de distribuição de leads e oferta ativa, caso o usuário(a) <strong>{{user.name}}</strong> faça parte de alguma dessas filas.</p>

        <!--*********************
                    broker
            *********************-->

        <section class="team-z">
            <ui-select-v2
                v-model="selectNewTean"
                label="Equipe:"
                item-label="label"
                return-value="value"
                :data="dataTeams"
                :loading="loadTeams"
                open-event="change-profile-teams"
                search-box="change-profile-teams"
                ajax-search
                @input='leaveToManager'

            />
        </section>
        <section class="manager-z">
            <ui-select-v2
                v-if="loadManager && !managerNotFound"
                v-model="selectNewManager"
                label="Gerente:"
                item-label="label"
                return-value="value"
                :data="loadManager"
                @input='leaveToBroker'
            />
        </section>
        <ui-select-v2
            v-if="loadBroker && !brokerNotFound"
            v-model="selectNewBroker"
            label="Corretor:"
            item-label="label"
            return-value="value"
            :data="loadBroker"
            @input='setLeave'
        />

        <div v-if="load" class="load">
            <ui-load-indicator
                bg-color="#e7e9f4"
                color="#69D296"
                :h="30"
                :stroke="5" />
        </div>
        <div v-if="managerNotFound" class="not-found">
            <p> <i aria-hidden='true' class="fad fa-user-times"/> Não encontramos nenhum Gerente</p>
        </div>
        <div v-if="brokerNotFound" class="not-found">
            <p> <i aria-hidden='true' class="fad fa-user-times"/> Não encontramos nenhum corretor</p>
        </div>

    </div>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui';
import { uiSelectV2 } from '@/components/ui/form';
import { team } from '@/services/axios';
export default {
    name: 'ui-broker-delete',
    components: {
        uiSelectV2,
        uiLoadIndicator
    },
    props: {
        idUser: {
            type: [String, Number],
            default: ''
        },
        user: {
            type: Object,
            default: () => {}
        },
        dataTeams: {
            type: Array,
            default: () => []
        },
        loadTeams: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            load: false,
            loadManager: null,
            selectNewTean: null,
            selectNewManager: null,
            loadBroker: null,
            selectNewBroker: null,
            managerNotFound: false,
            brokerNotFound: false,
        }
    },
    methods: {
        //ao selecionar o usuário
        leaveToManager(value) {
            this.load = true
            this.loadBroker = null
            this.loadManager = null
            this.managerNotFound = false
            this.brokerNotFound = false
            team.getManagersByTeam(value).then(res => {
                if(res.data.length == 0) {
                    this.managerNotFound = true
                    return this.load = false
                }
                this.loadManager = res.data.map(val => {
                return {value: val.manager_id, label: val.first_name, id: val.id}
                })
                this.load = false
            })
        },
        leaveToBroker(value) {
            this.load = true
            this.loadBroker = null
            team.getBrokersByManager(value).then(res => {
                this.loadBroker = []
                if(res.data.length == 0) {
                    this.brokerNotFound = true
                    return this.load = false
                }
                res.data.map(val => {
                    if (val.id !== this.idUser) {
                        this.loadBroker.push({value: val.id, label: val.first_name, id: val.id})
                    }
                })
                return this.load = false
            }).catch(() => {
                this.load = false
                this.brokerNotFound = true
            })
        },

        setLeave(value) {
            if(value.length == 0) {
                return this.$emit('desactive', 'remove', true)
            };
            this.$emit('desactive', 'remove', false)
            this.$emit('input', value, this.selectNewManager, this.selectNewTean)
        }
    }


}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>